var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShipBlue2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.2236,
    y: 0.617188,
    width: 1.5528,
    height: 7.76397,
    rx: 0.776398,
    fill: "#70B3FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3418,
    y: 7.14062,
    width: 9.31677,
    height: 7.76397,
    rx: 1.08696,
    fill: "#0F54A7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7576 11.7267C10.7951 11.1552 11.2696 10.7109 11.8422 10.7109H28.1576C28.7302 10.7109 29.2047 11.1552 29.2422 11.7267L30.017 23.5279C30.0582 24.1549 29.5607 24.6861 28.9324 24.6861H11.0674C10.4391 24.6861 9.94161 24.1549 9.98278 23.5279L10.7576 11.7267Z",
    fill: "#166DD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57385 25.6494C2.84587 24.5752 3.31781 23.1029 4.53463 22.652L19.6226 17.0618C19.8662 16.9715 20.1342 16.9715 20.3779 17.0618L35.4658 22.652C36.6826 23.1029 37.1545 24.5752 36.4266 25.6494L28.2039 37.783C27.8318 38.3321 27.2116 38.661 26.5483 38.661H20.0002H13.4521C12.7888 38.661 12.1686 38.3321 11.7965 37.783L3.57385 25.6494Z",
    fill: "#A9D1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57385 25.6494C2.84587 24.5752 3.31781 23.1029 4.53463 22.652L19.6226 17.0618C19.8662 16.9715 20.1342 16.9715 20.3779 17.0618L35.4658 22.652C36.6826 23.1029 37.1545 24.5752 36.4266 25.6494L28.2039 37.783C27.8318 38.3321 27.2116 38.661 26.5483 38.661H20.0002H13.4521C12.7888 38.661 12.1686 38.3321 11.7965 37.783L3.57385 25.6494Z",
    fill: "#A9D1FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57385 25.6494C2.84587 24.5752 3.31781 23.1029 4.53463 22.652L19.6226 17.0618C19.8662 16.9715 20.1342 16.9715 20.3779 17.0618L35.4658 22.652C36.6826 23.1029 37.1545 24.5752 36.4266 25.6494L28.2039 37.783C27.8318 38.3321 27.2116 38.661 26.5483 38.661H20.0002H13.4521C12.7888 38.661 12.1686 38.3321 11.7965 37.783L3.57385 25.6494Z",
    fill: "#A9D1FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57385 25.6494C2.84587 24.5752 3.31781 23.1029 4.53463 22.652L19.6226 17.0618C19.8662 16.9715 20.1342 16.9715 20.3779 17.0618L35.4658 22.652C36.6826 23.1029 37.1545 24.5752 36.4266 25.6494L28.2039 37.783C27.8318 38.3321 27.2116 38.661 26.5483 38.661H20.0002H13.4521C12.7888 38.661 12.1686 38.3321 11.7965 37.783L3.57385 25.6494Z",
    fill: "#A9D1FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.9219L35.4656 22.652C36.6824 23.1029 37.1543 24.5752 36.4264 25.6494L27.9321 38.1838C27.7298 38.4823 27.3928 38.661 27.0323 38.661H20V16.9219Z",
    fill: "#8CC2FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.9219L35.4656 22.652C36.6824 23.1029 37.1543 24.5752 36.4264 25.6494L27.9321 38.1838C27.7298 38.4823 27.3928 38.661 27.0323 38.661H20V16.9219Z",
    fill: "#8CC2FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.9219L35.4656 22.652C36.6824 23.1029 37.1543 24.5752 36.4264 25.6494L27.9321 38.1838C27.7298 38.4823 27.3928 38.661 27.0323 38.661H20V16.9219Z",
    fill: "#8CC2FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.9219L35.4656 22.652C36.6824 23.1029 37.1543 24.5752 36.4264 25.6494L27.9321 38.1838C27.7298 38.4823 27.3928 38.661 27.0323 38.661H20V16.9219Z",
    fill: "#70B3FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7764 6.02261V2.14062L24.9531 3.88095C25.1315 3.95527 25.1315 4.20797 24.9531 4.28229L20.7764 6.02261Z",
    fill: "#70B3FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.0127,
    y: 13.0391,
    width: 13.9752,
    height: 1.55279,
    rx: 0.776397,
    fill: "#70B3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShipBlue2);
export default __webpack_public_path__ + "static/media/icon-ship-blue2.d781ed361165f3cfb58cc446542de7d6.svg";
export { ForwardRef as ReactComponent };